import React, { Component } from 'react'
import { Action } from 'hljd'
import { observer } from 'mobx-react'

const Item = Action.Item

@observer
export default class extends Component {
  render() {
    const { activeTab, changeTab, countData } = this.props.store
    const { count, wait_count, push_count, guest_count, expired_count } =
      countData || {}
    return (
      <Action
        style={{ height: 50, marginBottom: 20 }}
        itemStyle={{ fontSize: 14 }}
        active={activeTab}
        onChange={changeTab}
      >
        <Item value="all">全部{count > 0 && count}</Item>
        <Item value="1">待处理{wait_count > 0 && wait_count}</Item>
        <Item value="2">已推送{push_count > 0 && push_count}</Item>
        <Item value="3">成为客资{guest_count > 0 && guest_count}</Item>
        <Item value="4">已过期{expired_count > 0 && expired_count}</Item>
      </Action>
    )
  }
}
